<div class="pl-[19px] pr-[19px] !mb-[60px] flex">
  <div class="!w-[100%]">
    <div class="h-auto !bg-[#F8F8F8]">
      <div class="container flex !pt-[25px] !pb-[25px]">
        <!-- <button class="">
      <mat-icon class="mr-6">keyboard_arrow_left</mat-icon>
    </button> -->
        <h3 class="!text-[20px] !text-[#21252A] !font-bold !ml-[20px]">
          {{ projectName }} - Pre Qualification Questionnaire
        </h3>
      </div>
    </div>

    <table class="w-full bg-[#fcfcfd] table-auto !mt-[20px]">
      <thead
        class="h-[50px] bg-[#DEE2E6] text-[#000000] !text-center justify-center !px-[20px]"
      >
        <tr>
          <th class="px-4 py-2 text-center w-auto">PQQ No.</th>
          <th class="px-4 py-2 text-center w-auto">Title</th>
          <th class="px-4 py-2 text-center w-auto">Reference No</th>
          <th class="px-4 py-2 text-center w-auto">Client</th>
          <th class="px-4 py-2 text-center w-auto">Issued</th>
          <th class="px-4 py-2 text-center w-auto">Deadline</th>
          <th class="px-4 py-2 text-center w-auto">Action</th>
        </tr>
      </thead>
      <tbody class="!text-center">
        <ng-container *ngFor="let pqq of pqqListing; let i = index">
          <tr
            class="hover:bg-[#E76B3F] hover:bg-opacity-[0.3] border-b-0"
            [ngClass]="{ 'bg-white': i % 2 === 0, 'bg-[#DEE2E6]': i % 2 !== 0 }"
          >
            <td
              class="border-b-0 px-4 py-2 w-auto cursor-pointer"
              (click)="openView(pqq?.id)"
            >
              {{ this.projectIdentifier }} - {{ pqq?.code }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto cursor-pointer">
              {{ pqq?.title }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto cursor-pointer">
              {{ pqq?.reference_number }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto">
              {{ pqq?.client }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto">
              {{ pqq?.issue_date }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto">
              {{ pqq?.submission_deadline }}
            </td>
            <td
              class="border-b-0 px-4 py-2 w-auto cursor-pointer"
              (click)="closeEoiSubmissions(pqq?.id)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="4"
                height="18"
                viewBox="0 0 4 18"
                fill="none"
              >
                <path
                  d="M1.99994 4.0682C2.95727 4.0682 3.73327 3.29218 3.73327 2.33488C3.73327 1.37759 2.95727 0.601562 1.99994 0.601562C1.0426 0.601562 0.266602 1.37759 0.266602 2.33488C0.266602 3.29218 1.0426 4.0682 1.99994 4.0682Z"
                  fill="black"
                />
                <path
                  d="M1.99994 10.7362C2.95727 10.7362 3.73327 9.9602 3.73327 9.00286C3.73327 8.04553 2.95727 7.26953 1.99994 7.26953C1.0426 7.26953 0.266602 8.04553 0.266602 9.00286C0.266602 9.9602 1.0426 10.7362 1.99994 10.7362Z"
                  fill="black"
                />
                <path
                  d="M3.73327 15.6669C3.73327 16.6243 2.95727 17.4003 1.99994 17.4003C1.0426 17.4003 0.266602 16.6243 0.266602 15.6669C0.266602 14.7096 1.0426 13.9336 1.99994 13.9336C2.95727 13.9336 3.73327 14.7096 3.73327 15.6669Z"
                  fill="black"
                />
              </svg>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<ng-container *ngIf="isCreate">
  <app-wrapper
    (handleDialog)="handleDialog()"
    [currentDialog]="currentDialog"
  ></app-wrapper>
</ng-container>
